<template>
<div>
  <card-reader
    @ready="scannerReady"
    @error="scannerError"
    @uid="handleUid"
    @info="handleInfo"
  />
  <p>STATUS: {{ status }}</p>
  <p>UID: {{ uid }}</p>
  <p>INFO: {{ info }}</p>
  </div>
  
</template>

<script>
export default {
  name: 'MyComponent',
  data() {
    return {
      status: '[scanner status]',
      uid: '',
      info: '',
    };
  },
  methods: {
    scannerReady() {
      this.status = 'Ready to scan';
    },
    scannerError(error) {
      this.status = `Error: ${error.message}`;
    },
    handleUid(uid) {
      this.uid = uid;
    },
    handleInfo(data) {
      this.info = data;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
